import { Flexbox, Form } from '@/components'
import { getIn } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'

export const getQuestionFieldName = (index, field) => ['questionnaire', 'questions', index, field].join('.')

function QuestionnaireQuestionRow({
  errors, index, onMoveDown, onMoveUp, onRemove,
  questionCount, touched,
}) {
  const descriptionName = getQuestionFieldName(index, 'description')
  const descriptionTouched = getIn(touched, descriptionName)
  const descriptionError = getIn(errors, descriptionName)
  const allowAttachmentsName = getQuestionFieldName(index, 'allowAttachments')
  const requiredName = getQuestionFieldName(index, 'required')

  return (
    <div className="tile mb-2">
      <div className="tile-icon">
        <div className="chip">
          {index + 1}
        </div>
      </div>
      <div className="tile-content">
        <Form.Group className={descriptionTouched && descriptionError ? 'has-error' : ''}>
          <Form.Label htmlFor={descriptionName}>
            Pergunta <span className="text-error">*</span>
          </Form.Label>
          <Form.ValidationField
            name={descriptionName}
            id={descriptionName}
            placeholder="Ex: O atendimento teve fraturas expostas?"
          />
          {descriptionTouched && descriptionError ? (
            <Form.Hint className="text-error">{descriptionError}</Form.Hint>
          ) : null}
        </Form.Group>
        <Flexbox.Columns>
          <Flexbox.Column className="col-4 col-sm-12">
            <Form.Group>
              <Form.Switch className="form-switch">
                <Form.ValidationField
                  type="checkbox"
                  name={allowAttachmentsName}
                  id={allowAttachmentsName}
                />
                <i className="form-icon" />
                &nbsp;Permite anexar fotos
              </Form.Switch>
            </Form.Group>
          </Flexbox.Column>
          <Flexbox.Column className="col-4 col-sm-12">
            <Form.Group>
              <Form.Switch className="form-switch">
                <Form.ValidationField
                  type="checkbox"
                  name={requiredName}
                  id={requiredName}
                />
                <i className="form-icon" />
                &nbsp;Obrigatória
              </Form.Switch>
            </Form.Group>
          </Flexbox.Column>
        </Flexbox.Columns>
      </div>
      <div className="tile-action" style={{ marginTop: '2rem' }}>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-sm btn-action"
            title="Mover para cima"
            disabled={index === 0}
            onClick={onMoveUp}
          >
            <i className="fas fa-arrow-up" />
          </button>
          <button
            type="button"
            className="btn btn-sm btn-action"
            title="Mover para baixo"
            disabled={index === questionCount - 1}
            onClick={onMoveDown}
          >
            <i className="fas fa-arrow-down" />
          </button>
          <button
            type="button"
            className="btn btn-sm btn-error btn-action"
            title="Remover pergunta"
            onClick={onRemove}
          >
            <i className="fas fa-trash" />
          </button>
        </div>
      </div>
    </div>
  )
}

QuestionnaireQuestionRow.propTypes = {
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  index: PropTypes.number.isRequired,
  onMoveDown: PropTypes.func.isRequired,
  onMoveUp: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  questionCount: PropTypes.number.isRequired,
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
}

export default QuestionnaireQuestionRow
